import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom'
import '../../../../styles/smart_wizard_all.css'
import { currencyConvertor, getMode, isEclipseOpsTruck, showAlert } from '../../../../Utils/Utility';
import BilledHeader from './BilledHeader'
import { useHistory, useLocation } from 'react-router';
import '../../../../styles/paymentdetails.css'
import { toast } from 'react-toastify';
import { injectIntl } from 'react-intl';
import { TTConvenienceFeeAction } from '@mobile-dev/platform/common/redux/actions/EclipseServiceFeeAction'
import Loader from '../../../Common/Loader';
import { clearError, clearTTConvenienceFee } from '@mobile-dev/platform/common/redux/actions/CommonAction';
import { format } from 'path';

function NewPaymentDetails({ intl, ...props }) {
    const id = props.match.params.id;
    let totalfeeamount = 0;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id)
    let unload_bill_amount = load.unloading_bill_amount;
    let tin = load.tax_id
    const [isDisabled, setDisabled] = useState(true);
    const [remainingAmount, setRemainingAmount] = useState(0);
    const [selection, Setselection] = useState("Full Payment")
    const [togglebutton, setTogglebutton] = useState(false)
    const location = useLocation();
    const [totalremainingAmount, setTotalremainingAmount] = useState(0);
    const history = useHistory();
    const { formatMessage } = intl;
    const TTConvenienceFee = useSelector(state => state.getTTConvenienceFee)
    const [updatedBillAmount, setUpdatedBillAmount] = useState(null)
    const [data, setData] = useState(load)
    const [total_bill_amount, settotal_bill_amount] = useState(data.total_bill_amount)
    const [total_paid, settotal_paid] = useState(data.total_paid)
    const [amount, setAmount] = useState(data.total_bill_amount - data.total_paid);

    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch()
    const paymentmethods = props.location.state.paymentmethods;

    useEffect(() => {
        if (location?.state?.totalremainingAmount) {
            setTotalremainingAmount(location?.state?.totalremainingAmount);
        }
        else {
            if (total_paid > 0) {
                setTotalremainingAmount(+total_bill_amount - +total_paid);
            }
        }
    }, []);

    useEffect(() => {
        if (data) {
            settotal_bill_amount(data.total_bill_amount)
            settotal_paid(data.total_paid)
            setAmount(data.total_bill_amount)
        }

    }, [data]);


    useEffect(() => {
        if (TTConvenienceFee?.convenienceFee) {
            const { UpdatedBillAmount } = TTConvenienceFee?.convenienceFee
            setIsLoading(false)
            setTimeout(() => {
                setUpdatedBillAmount(UpdatedBillAmount)
                setData({ ...data, total_bill_amount: UpdatedBillAmount })
                dispatch(clearTTConvenienceFee())
            }, 500)

        }
        if (TTConvenienceFee?.convenienceFeeError) {
            dispatch(clearError())
            getTTConvenienceFee()
        }
    }, [TTConvenienceFee])


    useEffect(() => {
        if (!isEclipseOpsTruck(data)) {
            getTTConvenienceFee()
        }
    }, [])

    const getTTConvenienceFee = () => {
        const initiateGetServiceFee = (type) => {
            const body = {
                "IDWarehouse": data?.warehouse_id,
                "paymentMode": getMode(type),
                "load_id": data?.load_id,
                "paymentType": data?.total_paid > 0 ? "Partial Payment" : "Full Payment",
                "amount": amount
            }

            setIsLoading(true)
            dispatch(TTConvenienceFeeAction(body))
        }
        switch (paymentmethods) {
            case "Relay":
                return initiateGetServiceFee("RELAY")
            case "ComData":
                return initiateGetServiceFee("COMDATA")
            case "EFS":
                return initiateGetServiceFee("EFS")
            case "T-Chek":
                return initiateGetServiceFee("TCHEK")
            case "CreditCard":
                return initiateGetServiceFee("CREDITCARD")
            case "Insta-Money":
                return initiateGetServiceFee("INSTAMONEY")
            case "Us-Bank":
                return initiateGetServiceFee("USBANK")
        }
       

    }


    const handleChange = (e) => {
        if (e.target.value === "Full Payment") {
            Setselection("Full Payment");
            setDisabled(true);
            setTogglebutton(false)
            setRemainingAmount(0);
            document.getElementById("Partial Amount").value = ""
            setAmount(total_bill_amount);
        }
        else if (e.target.value === "Partial Payment") {
            Setselection("Partial Payment");
            setDisabled(false);
            setTogglebutton(true)
        }
        else {
            Setselection("Partial Payment")
            setDisabled(false);
            let partialAmount = e.target.value;
            partialAmount =  partialAmount;

            const finalAmount = total_bill_amount - partialAmount;
            e.target.value ? setTogglebutton(false) : setTogglebutton(true)

            setRemainingAmount(currencyConvertor(finalAmount));
            setAmount(partialAmount);
        }


    }

    const handleSubmit = () => {
        if ((amount == 0 && !updatedBillAmount) || amount > total_bill_amount) {
            showAlert(toast.TYPE.WARNING, "Please enter valid amount");
        }
        else {

            if (selection === "Full Payment") {
                history.push({ pathname: `/paymentconfirmation/${id}`, state: { amount, paymentmethods, selection, remainingAmount, total_bill_amount } })
            } else if (selection === "Partial Payment") {
                history.push({ pathname: `/paymentconfirmation/${id}`, state: { amount, paymentmethods, selection, remainingAmount, total_bill_amount: load.total_bill_amount } })
            }

            return null;
        }


    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <BilledHeader path={`/billedDetails/${id}`} />
                        <div className="container_block" style={{ padding: '40px' }}>
                            <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                                <div id="step-2" className="tab-pane" role="tabpanel" aria-labelledby="step-2">
                                    <section>
                                        <h4 className="mb-3 txtwhite">{formatMessage({ id: "app.payment_details" })}</h4>
                                        {
                                            updatedBillAmount && total_bill_amount &&
                                            <p>{formatMessage({ id: "app.total_payment_amount" })}
                                                {/* {
                                                // feeamount &&
                                                     && totalremainingAmount > 0 ?
                                                        <strong className="remaining_amt ml-1">
                                                            ${currencyConvertor(totalremainingAmount)}
                                                        </strong>
                                                        : */}
                                                    <strong className="remaining_amt ml-1">
                                                        ${currencyConvertor(total_bill_amount)}
                                                    </strong>
                                                {/* } */}
                                            </p>
                                        }

                                        <div className="row">
                                            <div className="col-4">
                                                <div className="checkbox-circle">

                                                    <label className="active">
                                                        <input type="radio" name="PaymentRadio"
                                                            value="Full Payment" onChange={handleChange} defaultChecked />{formatMessage({ id: "app.full_payment" })}
                                                        <span className="checkmark"></span>
                                                    </label>
                                                    {totalremainingAmount <= 0 &&
                                                        <>
                                                            <label>
                                                                <input type="radio" name="PaymentRadio"
                                                                    value="Partial Payment" onChange={handleChange} />{formatMessage({ id: "app.partial_payment" })}
                                                                <span className="checkmark"></span>
                                                            </label>

                                                            <div className="col-12 ml-2 col-sm">
                                                                <input type="number" className="form-control mb-2"
                                                                    style={{ opacity: '1 !important' }} id="Partial Amount" disabled={isDisabled} onChange={handleChange} pattern="[0-9]+" />
                                                                {/* <span>{formatMessage({ id: "app.remaining_amount" })} <strong className="remaining_amt">${currencyConvertor(remainingAmount)}</strong></span> */}

                                                                <span><strong className="remaining_amt">{formatMessage({ id: "app.PAYMENT_TYPE_NOTE" })}</strong></span>

                                                            </div>

                                                        </>
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                        <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>

                                            <button type="button" disabled={togglebutton} className="btn sw-btn-next btn-chartreuse float-right" onClick={handleSubmit}>{formatMessage({ id: "app.continue" })}</button>

                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <Loader />}

        </div>
    )
}

export default injectIntl(NewPaymentDetails);

